/**
 * constants_env  定义系统框架相关的常量
 * @author sin
 * @date 2018-01-12
 *
 */


//系统属性
let env = {
    prod: 'https://learning-pv.saicmotor.com',
    dev: 'https://cyc-api-dev.cnttt.com',
    test: 'https://learning-qa.saicmotortest.com',
    local: 'https://cyc-test.yhliu.cn',//'http://localhost:3000'
}
let stu_env = {
    prod: 'https://learning-pv.saicmotor.com/user',
    dev: 'https://cyc-dev.cnttt.com:13998',
    test: 'https://learning-qa.saicmotortest.com/user',
    local: '',//'http://localhost:3000'
}
export const nev_env = {
    prod: 'https://learning-pv.saicmotor.com/userh5',
    dev: 'https://cyc-dev.cnttt.com:13997',
    test: 'https://learning-qa.saicmotortest.com/userh5',
    local: ''
}
//访问地址
export const env_host = process.env && process.env.REACT_APP_ENV ? env[process.env.REACT_APP_ENV] : env['local']

//学员端的地址
export const sys_user_url = process.env && process.env.REACT_APP_ENV ? stu_env[process.env.REACT_APP_ENV] : stu_env['local']

//存储storage的key
export const app_storage_key = 'cyc-manager';

//html的title
export const app_html_title = '系统首页 - {title}';

//用户/系统日志记录的key
export const app_user_log_key = app_storage_key + '_user_log_key';
export const app_sys_log_key = app_storage_key + '_sys_log_key';

//系统名字
export const sys_short_name = '管理系统';
export const sys_name_prefix = '新培训平台';
export const sys_name_suffix = '新培训平台管理系统'
export const sys_full_name = '新培训平台在线学习'

//RSA加密密码 公钥
export const sys_public_key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCIUGwMEGXHqWwiw92NJzVDy4eiTeOCv270voH1oIP66u3QzrhaXUL6/brPk6xNW95gn/GvGImJ4rdOW1q+cLk61GZM6tkYAo04/7EkrT5K4TleSNvG/ktj3Ox4iv3gcOQiXZkZ+Oi0gfM1Hezcn5DbwTofXnhKis96oiidQvDlkQIDAQAB'


let env_ali_confs = {
  prod: {
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
    region: 'oss-cn-shanghai',
    bucket: 'oss-prd-sh-dm-lats',
  },
  dev: {
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
    region: 'oss-cn-shanghai',
    bucket: 'oss-qa-sh-dm-lats',
  },
  test: {
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
    region: 'oss-cn-shanghai',
    bucket: 'oss-qa-sh-dm-lats',
  },
  local: {
    endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
    region: 'oss-cn-shanghai',
    bucket: 'oss-qa-sh-dm-lats',
  }
}
let env_ali_conf = env_ali_confs[process.env?.REACT_APP_ENV || 'local']  || {}


//oss key
export const sys_ali_key = 'CloudAli'
export const sys_ali_endpoint = env_ali_conf.endpoint
export const sys_ali_bucket = env_ali_conf.bucket
export const sys_ali_region = env_ali_conf.region
export const sys_ali_partSize = 1 * 102400

export const sys_endpoint = 'admin'

//登录地址的路有
export const sys_login_path = '/sign/login'

//内容 公告分类的id
export const sys_content_category_gg_id = '1'

//获取CYC移动课堂跳转的短链接
export const sys_get_app_link = (url) => { return `${sys_user_url}/#/weChat/share?url=${btoa(url)}&sgmlmsPath=true` }
